import { useParams } from 'react-router-dom';
import { InteractionTwoTone } from '@ant-design/icons';
import { Button } from 'antd';

import { refetchSnapDetailsAction } from 'containers/Snaps/Snap/store';

import { usePutRequest } from 'hooks';

import { Transaction } from 'codegen';

export const UpdateTransaction = ({
  status,
  canUpdate,
  transactionId,
  refetchTransactions,
}: {
  status?: Transaction.status,
  canUpdate: boolean;
  transactionId?: number;
  refetchTransactions: () => void;
}) => {
  const { snapId } = useParams();

  const [updateTransaction, { loading }] = usePutRequest({
    url: `/snaps/${snapId}/transactions/${transactionId}`,
    options: {
      onSuccess: () => {
        refetchTransactions();
        refetchSnapDetailsAction();
      },
    },
  });

  const isBackedOut = status === Transaction.status.BACKED_OUT;

  if (!canUpdate || isBackedOut) {
    return null;
  }

  return (
    <Button
      type='text'
      icon={<InteractionTwoTone title='Update' />}
      loading={loading}
      onClick={() => updateTransaction()}
    />
  );
};
